import styled from 'styled-components';

export const StyledProductList = styled.section`
    position: relative;
	padding-top: 100px;

    .product-list-category {
        padding: 200px 0 170px;
        background: white;
        position: relative;
        overflow: hidden;
		
		&:nth-of-type(1){
			padding-top: 60px;
		}
		
		@media(max-width: 767px){
			padding: 120px 0 90px;
		}

        &:nth-of-type(even) {
            background: #EFEFEF;
           
			
        }
        &:nth-of-type(2n){
            .fixed-left {
                opacity: 0;


            }
            .fixed-right {
                opacity: 1;


            }
        }
        &:nth-of-type(4n){
            .fixed-left {
                opacity: 1;


            }
            .fixed-right {
                opacity: 0;


            }
        }
		

        .container {
            padding-top: 30px;
            position: relative;

            &:after {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                height: 1px;
                width: calc(100% - 30px);
                margin: 0 auto;
                content: '';
                border-top: 1px solid #15263780;
            }
        }

        h3 {
            font-weight: 700;
            font-size: 2rem; /* 32px */
            line-height: 2.25rem; /* 36px */
            letter-spacing: 0;
            margin-bottom: 60px;
        }

	

    }

    .fixed-right {
        position: absolute;
        right: 0;
        top: 0;
        opacity: 0;


    }

    .fixed-left {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        opacity: 0;

    }


`;
